
export enum ProvisionedApplicationsTypes {
    Airsweb = 'airsweb',
}
